export default __webpack_public_path__ + "static/media/dfi-razer-silver-freezer.4050100c.svg";